import React from 'react'
import Button from 'srcReact/components/common2/Button'
import IconButtonWithText from 'srcReact/components/common2/IconButtonWithText'
import Spinner from 'srcReact/components/common2/Spinner'
import styles from './styles.module.scss'

export default function PureSettings({
  show,
  title,
  iconSize,
  settings,
  actionButtons,
  isSaving,
  handleChange,
  handleSave,
  handleCancel,
  className,
  aboutClassName
}) {
  return (
    <div className={`${styles.container} ${show && styles.showContainer} ${className}`}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.optionsContainer}>
        {settings.map((setting) => {
          return (
            <IconButtonWithText
              selected={setting.isSelected}
              icon={setting.iconName}
              iconSize={iconSize}
              text={setting.text}
              textCSS={styles.optionText}
              onClick={() => handleChange(setting.value)}
            />
          )
        })}
      </div>
      <div className={`${styles.about} ${aboutClassName}`}>
        {settings.map((setting) => {
          return setting.isSelected && setting.aboutText
        })}
      </div>
      {actionButtons?.show && (
        <div className={styles.buttonWrapper}>
          <Button style='tertiary' type='button' handleClick={handleCancel} text={actionButtons.cancelText} />
          <Button
            type='button'
            handleClick={handleSave}
            text={isSaving ? <Spinner isWhite={true} /> : actionButtons.saveText}
          />
        </div>
      )}
    </div>
  )
}
